<div class="modal-header">
    <incident-dialog-header [incident]="data.incident" (close)="cancel()"></incident-dialog-header>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="(null != validationResults) && (null != validationResults.validationResults) && (0 != validationResults.validationResults.length)"></validation-results>
    <h2 class="btn--h2-hack"><button class="icon--download btn--default" type="button" title="Last Reevaluated by: {{this.lastReevaluatedBy}}" *ngIf="data.incident.incidentNumberId > 0" (click)="reevaluateAndUpdateProhibition(data.incident.incidentNumberId)">Reevaluate Incident</button></h2>
    <incident-dialog-content [parent]="this" [fieldsTemplate]="fieldsTemplate" [formGroup]="incidentForm" (occurrenceDateBlur)="occurrenceDateBlur($event)" (occurrenceDateChanged)="occurrenceDateChanged($event)">
        <ng-template #fieldsTemplate>
        </ng-template>
    </incident-dialog-content>
    <form [formGroup]="incidentForm" autocomplete="off" *ngIf="showUserInput">
        <h2>Incident Details</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <user-input type="bool" [parent]="this" label="Occurred in Commercial Vehicle" name="commercialMotorVehicleIndicator" id="commercialMotorVehicleIndicator" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <user-input type="bool" [parent]="this" label="Occurred While Transporting Hazardous Materials" name="hazardousMaterialIndicator" id="hazardousMaterialIndicator" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <user-input type="bool" [parent]="this" label="Occurred While Transporting 16 or More Passengers" name="passengerIndicator" id="passengerIndicator" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <user-input type="bool" [parent]="this" label="CDL Holder" name="isCDLHolder" id="isCDLHolder" [isRequired]="false" catchChange="true" catchChangeIndex="0"></user-input>
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <label>Driver License Number</label>
                    <input type="text" class="mvd_form-control" formControlName="driverLicenseNumber" maxlength="25" />
                </div>
                <div class="col-sm-12 mvd_form-group">
                    <label>Driver License jurisdiction</label>
                    <select class="mvd_form-control" formControlName="driverLicenseJurisdiction">
                        <option value="">- Select -</option>
                        <option *ngFor="let source of jurisdictions" value="{{ source.value }}">{{ source.text }}</option>
                    </select>
                </div>
            </div>
        </fieldset>
        <h2>Medical Alert Type(s)</h2>
        <table class="mvd_table--primeng">
            <thead>
                <tr>
                    <th>Alert ID</th>
                    <th>Alert Type</th>
                    <th class="w--icon">Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let type of data.incident.medicalAlertTypes">
                    <td>{{type.medicalAlertTypeId}}</td>
                    <td>{{type.medicalAlertTypeDisplayValue}}</td>
                    <td class="text-center"><a class="icon--delete" title="Delete" href="javascript:void(0)" (click)="deleteMedicalAlert(type.medicalAlertTypeId)" *ngIf="!data.isReadOnly"></a></td>
                </tr>
            </tbody>
        </table>
        <div class="row" *ngIf="!data.isReadOnly">
            <div class="col-sm-4 mvd_form-group">
                <user-input type="list" [parent]="this" label="Medical Alert Type" name="medicalAlertTypeList" id="medicalAlertTypeList" [isRequired]="false" [showRequired]="true" [list]="alertTypes" listValueMember="value" listDisplayMember="text" catchChange="true" catchChangeIndex="0"></user-input>
            </div>
            <div class="col-sm-4 mvd_form-group">
                <button class="icon--add btn--default" type="button" (click)="addMedicalAlert()">Add Selected</button>
            </div>
        </div>
    </form>
    <incident-updated [updatedBy]="data.incident.updatedBy" [updatedDate]="data.incident.updatedDate"></incident-updated>
</div>
<div class="modal-footer">
    <incident-dialog-footer [incident]="data.incident" [isReadOnly]="data.isReadOnly" [isDisabled]="!incidentForm.valid" [isLoading]="showButtonLoading" (cancel)="cancel()" (save)="saveIncident()"></incident-dialog-footer>
</div>